<div class="mep-dialog-header-icon">
	<mat-icon>download</mat-icon>
</div>
<div class="mep-dialog-title">{{ _lang("title") }}</div>
<div class="mep-dialog-content" mat-dialog-content>
	<div class="mep-text-big">
		<app-file-drag-drop [(ngModel)]="resourceRequestFile.file" (ngModelChange)="onFileChosen($event)">
		</app-file-drag-drop>

		<div class="center-checkbox-container">
			<mat-checkbox
				matTooltip="{{ _lang('checkbox-tooltip') }}"
				class="center-checkbox"
				[(ngModel)]="resourceRequestFile.visibleOverall"
				[checked]="resourceRequestFile.visibleOverall"
			>
				<span class="checkbox-text">{{ _lang("checkbox-text") }}</span>
			</mat-checkbox>
		</div>

		<mat-form-field class="w-100">
			<mat-label>{{ _lang("comment") }}</mat-label>
			<input matInput type="text" [(ngModel)]="resourceRequestFile.comment" autocomplete="off" />
		</mat-form-field>
	</div>
</div>

<div class="mep-dialog-actions">
	<button class="mep-btn-dialog-secondary" appEscapeHotkey (click)="cancel()">
		{{ "mep.components.general.cancel" | translate }}
	</button>
	<button class="mep-btn-dialog-primary" (click)="save()" appSaveHotkey>
		{{ "mep.components.general.save" | translate }}
	</button>
</div>
